module.exports = __webpack_public_path__ + "img/shop_shelves.e5103e59.png";